import { Redirect, useLocation } from '@reach/router';
import { AppPath, SESSION_EXPIRED_MESSAGE } from 'appConstants';
import { hasLiveSession, signInPathFor } from 'helpers/session';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthMessage, selectSignedIn, signOut } from 'reducers/auth';

export const Private: React.FC<any> = ({ children }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isSignedIn = useSelector(selectSignedIn);
  const authMessage = useSelector(selectAuthMessage);

  // The app can still think it is signed in after the session has gone, e.g. it expired while the
  // tab was open, or another tab signed out. Its page scopes are gone too, so carrying on would
  // show the no-permissions message instead of sign-in.
  const sessionLost = isSignedIn && !hasLiveSession();

  useEffect(() => {
    if (sessionLost) dispatch(signOut(SESSION_EXPIRED_MESSAGE));
  }, [sessionLost, dispatch]);

  if (sessionLost) return null;

  if (!isSignedIn) {
    return (
      <Redirect
        noThrow
        to={
          authMessage === SESSION_EXPIRED_MESSAGE
            ? signInPathFor(pathname)
            : AppPath.SIGN_IN
        }
      />
    );
  }

  return <>{children}</>;
};

export default Private;
